<template>
    <div>
        <div class="commissioning-sheet__completed-item">
            <span>A</span>
            <div>
                <p>View Commissioning Sheet</p>
                <span class="arrowlink mt-md">
                    <a target="_blank" :href="`/account/job/${job}/CommissioningSheet/calculate/download`">Download</a>
                    <svg class="icon">
                        <use xlink:href="#arrow-right" />
                    </svg>
                </span>
            </div>
        </div>
        <div class="commissioning-sheet__completed-item">
            <span>B</span>
            <div>
                <p class="mb-lg">Email Commissioning Sheet</p>

                <form class="commissioning-sheet__email mt-xl">
                    <h6 class="small semi mb-sm">
                        <span class="text--grey-dark">Separate address with comma</span>
                        <span class="text--grey-light">1MB</span>
                    </h6>
                    <div>
                        <input v-model="email" type="text" required placeholder="Type here">
                        <button class="btn btn--ghost btn--full-mobile" @click.prevent="sendEmail">Email</button>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>
<script>
import { mapActions } from 'vuex';

export default {
    props: {
        job: {
            type: Number,
            required: true,
        },

        jobObject: {
            type: Object,
            required: true,
        },

        commissioningSheet: {
            type: Object,
            required: true,
        }
    },

    data() {
        return {
            email: '',
            products: JSON.parse(this.$root.products),
            configuration: JSON.parse(this.$root.configuration),
        }
    },

    computed: {
        currentJob() {
            return this.jobObject.details;
        }
    },

    mounted() {
        document.body.scrollTop = 0;

        const commissioningSheetCompleted = {...this.commissioningSheet, completed: true};

        this.populate();
        this.updateField({ field: 'status', value: 'Complete' });
        this.updateField({ field: 'commissioningSheet', value: commissioningSheetCompleted });
        this.updateJob();
    },

    methods: {
        ...mapActions('job', ['populateJob', 'updateField', 'updateJob']),
        ...mapActions('configuration', ['populateConfiguration']),

        sendEmail() {
            window.location.href = `/account/job/${this.job}/CommissioningSheet/share/${this.email}`;
        },

        populate() {
            this.populateJob({
                id: this.job,
                ...this.currentJob
            });

            this.populateConfiguration({
                products: this.products,
                configuration: this.configuration
            });
        },
    }
}
</script>
